import { getCmsHomeBannerListAction } from "../../../Actions/LogicActions/CmsHomePageBanner/GetCmsHomeBannerListAction";
import { getCmsStopsListAction } from "../../../Actions/LogicActions/Search/GetCmsStopsListAction";
import { populateSearchForCmsAction } from "../../../Actions/UIActions/Search/PopulateSearchForCmsAction";
import { _eventBus } from "../../../core/events/EventBus";
import { StepDefinition } from "../../../core/flows/StepDefinition";
import { StepFlow } from "../../../core/flows/StepFlow";
import { evtTree } from "../../../Orchestrator/ConstantTree";
import { IPopulateSearchForCmsActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/IPopulateSearchForCmsActionParams";
import { IHomeBannerDetailGetParams } from "../../../Orchestrator/Types/Interface/ICmsHomePageBanner";

export class HomeBannerWidgetStep extends StepFlow {
  get stepName() {
    return "BannerWidgetStep";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on({
        eventName: evtTree.Banner.List.Get,
        handler: async () => {
          await getCmsHomeBannerListAction.execute();
          await getCmsStopsListAction.execute();
        },
      })
    );
    this.registerEventSubscription(
      _eventBus.on<IPopulateSearchForCmsActionParams, void>({
        eventName: evtTree.Banner.BookNow.Click,
        handler: async ({ data }) => {
          populateSearchForCmsAction.setParams(data!);
          await populateSearchForCmsAction.execute();
        },
      })
    );
  }

  async onExecute(): Promise<void> {
    console.log("HomeBannerWidgetStep Init Step Execute...");

    this.eventBus.emit({
      eventName: evtTree.Banner.List.Get,
    });
  }
}
export const homeBannerWidgetStepDeclaration = new StepDefinition({
  stepName: "HomeBannerWidgetStep",
  stepClass: HomeBannerWidgetStep,
});
